import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { RECIPIENT_DATA } from '#src/app/pages/racialJusticeFund/shared/consts';

export const RecipientSection: React.FC = () => {
	return (
		<div className="bg-gradient-background-light-1 py-8">
			<div className="container h-full px-2 md:px-4">
				<div>
					<Text className="py-2" variant="heading" as="h2" size="large">
						Change.org’s Racial Justice Fund grants were awarded to the following organizations:
					</Text>
					<ul className="columns-2 p-2 md:columns-3">
						{RECIPIENT_DATA.map((r) => (
							<li className="ml-4 list-item list-disc" key={r}>
								<Text>{r}</Text>
							</li>
						))}
					</ul>
				</div>
			</div>
		</div>
	);
};
